import { render, staticRenderFns } from "./NewDoorphone.vue?vue&type=template&id=7c083a3c&scoped=true"
import script from "./NewDoorphone.vue?vue&type=script&lang=js"
export * from "./NewDoorphone.vue?vue&type=script&lang=js"
import style0 from "./NewDoorphone.vue?vue&type=style&index=0&id=7c083a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c083a3c",
  null
  
)

export default component.exports